export default __webpack_public_path__ + "static/media/normal.b0aec7d8.svg";